{/* INCOME_VERIFICATION_TYPES */}
export const INCOME_VERIFICATION_TYPES = [
    { value: "FullDoc", label: "Full Documentation" },
    { value: "PersonalBankStmt12Mos", label: "12 Mo. Personal Bank Statement" },
    { value: "PersonalBankStmt24Mos", label: "24 Mo. Personal Bank Statement" },
    { value: "BusinessBankStmt12Mos", label: "12 Mo. Business Bank Statement" },
    { value: "BusinessBankStmt24Mos", label: "24 Mo. Business Bank Statement" },
    { value: "AssetRelated", label: "Asset Related" },
    { value: "InvestorDscr", label: "DSCR" },
    { value: "InvestorNoRatio", label: "Investor - No Ratio" },
    { value: "PLBankStmt1Yr", label: "P&L with Bank Statements: 1 Year" },
    { value: "PLBankStmt2Yr", label: "P&L with Bank Statements: 2 Year" },
    { value: "OneYear1099", label: "One Year 1099" },
    { value: "TwoYear1099", label: "Two Year 1099" }
];
  
{/* LOAN_PURPOSE_TYPES */}
export const LOAN_PURPOSE_TYPES = [
    { value: "Purchase", label: "Purchase" },
    { value: "RefiRateTermLimitedCO", label: "Rate/Term Refinance" },
    { value: "RefiCashout", label: "Cash Out Refinance" }
];

export const PREPAYMENT_PENALTY_OPTIONAL = [
  { label: "None", value: "None" },
  { label: "1 Year", value: "OneYear" },
  { label: "2 Year", value: "TwoYear" },
  { label: "3 Year", value: "ThreeYear" },
  { label: "4 Year", value: "FourYear" },
  { label: "5 Year", value: "FiveYear" }
];

{/* ESCROW_WAIVER */}
export const ESCROW_WAIVER = [
  { label: "Yes - Waive Escrows", value: "Yes" },
  { label: "No - Do not waive Escrows", value: "No" }
];


{/* YES NO */}
export const YES_NO = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];


{/* Citizenship Options */}
export const CITIZENSHIP = [
  { value: "USCitizen", label: "U.S. Citizen" },
  { value: "PermResidentAlien", label: "Permanent Resident Alien" },
  { value: "NonPermResidentAlien", label: "Non-Permanent Resident Alien" },
  { value: "ForeignNational", label: "Foreign National" }
];

/* HOUSING_EVENT_TYPE Options */
export const HOUSING_EVENT_TYPE = [
  { value: "None", label: "None" },
  { value: "DeedInLieu", label: "Deed In Lieu" },
  { value: "Foreclosure", label: "Foreclosure" },
  { value: "Modification", label: "Modification" },
  { value: "ShortSale", label: "Short Sale" },
  { value: "Forbearance", label: "Forbearance" }
];

/* HOUSE_EVENT_SEASONING Options */
export const HOUSE_EVENT_SEASONING = [
  { value: "NotApplicable", label: "Not Applicable" },
  { value: "Last1To12Months", label: "Last 1 to 12 Months" },
  { value: "Last13To24Months", label: "Last 13 to 24 Months" },
  { value: "Last25To36Months", label: "Last 25 to 36 Months" },
  { value: "Last37To48Months", label: "Last 37 to 48 Months" },
  { value: "Last49To60Months", label: "Last 49 to 60 Months" },
  { value: "MoreThanFiveYearsAgo", label: "More than 5 Years Ago" }
];

/* BANKRUPTCY_TYPE Options */
export const BANKRUPTCY_TYPE = [
  { value: "None", label: "None" },
  { value: "Chapter7", label: "Chapter 7" },
  { value: "Chapter11", label: "Chapter 11" },
  { value: "Chapter13", label: "Chapter 13" }
];

/* BANKRUPTCY_OUTCOME Options */
export const BANKRUPTCY_OUTCOME = [
  { value: "NotApplicable", label: "Not Applicable" },
  { value: "Discharged", label: "Discharged" },
  { value: "Dismissed", label: "Dismissed" },
  { value: "OpenOrPending", label: "Open Or Pending" }
];

/* BANKRUPTCY_SEASONING Options */
export const BANKRUPTCY_SEASONING = [
  { value: "NotApplicable", label: "Not Applicable" },
  { value: "Last1To12Months", label: "Last 1 to 12 Months" },
  { value: "Last13To24Months", label: "Last 13 to 24 Months" },
  { value: "Last25To36Months", label: "Last 25 to 36 Months" },
  { value: "Last37To48Months", label: "Last 37 to 48 Months" },
  { value: "Last49To60Months", label: "Last 49 to 60 Months" },
  { value: "MoreThanFiveYearsAgo", label: "More than 5 Years Ago" }
];

/* PROPERTY_TYPE Options */
export const PROPERTY_TYPE = [
  { value: "SingleFamily", label: "Single Family" },
  { value: "Condo", label: "Condo" },
  { value: "Condotel", label: "Condotel" },
  { value: "NonWarrantableCondo", label: "Non-Warrantable Condo" },
  { value: "PUD", label: "Planned Unit Development" },
  { value: "Townhouse", label: "Townhouse" }
];

/* OCCUPANCY Options */
export const OCCUPANCY = [
  { value: "PrimaryResidence", label: "Primary" },
  { value: "SecondHome", label: "Secondary" },
  { value: "InvestmentProperty", label: "Investment" }
];

export const TERMS = [
  { label: "40", value: "FortyYear" },
  { label: "30", value: "ThirtyYear" },
  { label: "25", value: "TwentyFiveYear" },
  { label: "20", value: "TwentyYear" },
  { label: "15", value: "FifteenYear" },
  { label: "10", value: "TenYear" },
  { label: "7", value: "SevenYear" },
  { label: "5", value: "FiveYear" }
];

export const AMORTIZATION_TYPES = [
  { label: "Fixed", value: "Fixed" },
  { label: "ARM", value: "ARM" }
];

export const ARM_FIXED_TERMS = [
  { label: "5 years", value: "FiveYear" },
  { label: "7 years", value: "SevenYear" },
  { label: "10 years", value: "TenYear" }
];

export const DESIRED_LOCK_PERIOD = [
  { label: "15", value: "15" },
  { label: "30", value: "30" },
  { label: "45", value: "45" },
  { label: "60", value: "60" }
];

export const PRODUCT_TYPES = [
  { label: "Standard Products", value: "StandardProducts" },
  { label: "Expanded Guidelines", value: "ExpandedGuidelines" }
];

export const LOAN_TYPES = [
  { label: "Conforming", value: "Conforming" },
  { label: "Non-Conforming", value: "NonConforming" },
  { label: "Conventional", value: "Conventional" }
];

export const LIEN_TYPES = [
  { label: "First Lien", value: "First" },
]

export const LENDER_VS_BORROW = [
  { label: "Lender Paid", value: "YesLenderPaid" },
  { label: "Borrower Paid", value: "NoBuyerPaid" },
];

export const PROPERTY_UNITS = [
  { label: "One Unit", value: "OneUnit" },
  { label: "Two Units", value: "TwoUnits" },
  { label: "Three Units", value: "ThreeUnits" },
  { label: "Four Units", value: "FourUnits" },
  { label: "Five Units", value: "FiveUnits" },
  { label: "Six Units", value: "SixUnits" },
  { label: "Seven Units", value: "SevenUnits" },
  { label: "Eight Units", value: "EightUnits" },
];